import { render, staticRenderFns } from "./UpdateExamType.vue?vue&type=template&id=00673c60&scoped=true&"
import script from "./UpdateExamType.vue?vue&type=script&lang=js&"
export * from "./UpdateExamType.vue?vue&type=script&lang=js&"
import style0 from "./UpdateExamType.vue?vue&type=style&index=0&id=00673c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00673c60",
  null
  
)

export default component.exports